<template>
    <div class="su-view su-admin promocode-view">
        <SubTitle :title="'Промокоды'" :backBtn="true" />

        <div class="promocode-controls">
            <Search @search='onSearch' />
            <div class="promocode-controls__right">
                <div class="promocode-controls__count" v-if="totalCount">
                    <span class="promocode-controls__count-label">Всего:</span>
                    <span class="promocode-controls__count-value">{{ totalCount }}</span>
                </div>
                <Button @click="openCreateModal">Создать</Button>
            </div>
        </div>

        <div class="users-body promocode-body" @scroll="handleScroll">
            <PromocodeTable
                :promocodeList="promocodeList"
                :loading="loading"
                @edit="openEditModal"
                @delete="openDeletePopup"
            />
        </div>

        <!-- Модальное окно создания/редактирования -->
        <PromocodeModal
            :show="showModal"
            :promocode="selectedPromocode"
            @close="closeModal"
            @saved="onSaved"
        />

        <!-- Popup удаления -->
        <transition name="fadeIn">
            <div class="popup" v-if="showPopupDel" @click="closeDeletePopup">
                <div class="popup__window" @click.stop="">
                    <div class="popup__inner">
                        <div class="popup__title">
                            Удалить промокод "{{ promocodeForDel?.code }}"?
                        </div>
                        <div class="popup__controlls">
                            <Button :class="'btn--red'" @click="deletePromocode">Удалить</Button>
                            <Button :class="'btn--grey'" @click="closeDeletePopup">Отмена</Button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import API from "@/services/API";
    import Loader from '@/components/Loader.vue'
    import Button from '@/components/UI/Button'
    import Search from '@/components/Controlls/Search.vue'
    import SubTitle from '@/components/UI/SubTitle.vue'
    import PromocodeTable from '@/components/PromocodeTable/Table.vue'
    import PromocodeModal from '@/components/PromocodeModal.vue'

    export default {
        name: 'PromocodeView',
        components: {
            Loader,
            Search,
            SubTitle,
            Button,
            PromocodeTable,
            PromocodeModal,
        },
        data() {
            return {
                showModal: false,
                showPopupDel: false,
                promocodeForDel: null,
                selectedPromocode: null,
                upload: false,
                queryOption: {
                    searchTxt: '',
                    ordering: {},
                    filters: {},
                    limit: 20
                }
            }
        },
        created() {
            this.$store.dispatch('fetchPromocodes', this.queryOption)
        },
        computed: {
            promocodeList() {
                return this.$store.getters.getAllPromocodes
            },
            loading() {
                return this.$store.getters.getPromocodesLoading
            },
            totalCount() {
                return this.$store.getters.getPromocodesTotalCount
            },
        },
        methods: {
            onSearch(searchTxt) {
                let queryOption = this.$store.state.promocode.queryObject
                queryOption.searchTxt = searchTxt
                queryOption.offset = null
                this.$store.dispatch('fetchPromocodes', queryOption)
            },
            openCreateModal() {
                this.selectedPromocode = null
                this.showModal = true
            },
            openEditModal(promocode) {
                this.selectedPromocode = promocode
                this.showModal = true
            },
            closeModal() {
                this.showModal = false
                this.selectedPromocode = null
            },
            onSaved() {
                // данные обновятся автоматически через store
            },
            openDeletePopup(promocode) {
                this.showPopupDel = true
                this.promocodeForDel = promocode
            },
            closeDeletePopup() {
                this.showPopupDel = false
                this.promocodeForDel = null
            },
            async deletePromocode() {
                if (!this.promocodeForDel) return

                await this.$store.dispatch('deletePromocode', this.promocodeForDel.id)
                this.closeDeletePopup()
            },
            async handleScroll(event) {
                const scrollBlock = event.target
                await API.uploadByScroll(this, scrollBlock, 'Promocode')
            }
        }
    }
</script>

<style lang="scss">
    .promocode-view {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .promocode-controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
        flex-wrap: wrap;
        gap: 1.6rem;

        &__right {
            display: flex;
            align-items: center;
            gap: 1.6rem;
        }

        &__count {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.6rem;
            padding: 0.6rem 1.2rem;
            background: #F0F4F8;
            border-radius: 2rem;
        }

        &__count-label {
            color: #8A8C96;
            font-size: 1.3rem;
        }

        &__count-value {
            color: #191B1D;
            font-size: 1.4rem;
            font-weight: 600;
        }

        .btn {
            padding: 1.2rem 2.4rem;
        }
    }

    .promocode-body {
        flex: 1;
        overflow-y: auto;
    }
</style>